var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"PollNumberResultsBar"},[_c('PollResultsChartBar',{attrs:{"chart-bar-data":_vm.chartData,"min":_vm.minValue,"max":_vm.maxValue,"data-label-callback":_vm.dataLabel,"tooltip-label-callback":_vm.tooltipLabel}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }